import React, { Component } from "react";
import { Translate } from "react-redux-i18n";
import { connect } from "react-redux";
import HomeCollectionsTabs from "../../components/HomeCollectionsTabs";
import SuggestionCard from "../../components/SuggestionCard";
import CircleCard from "../../components/CircleCard";
import CircleDecorator from "../../containers/CircleDecorator";
import { fetchCircleCollections } from "../../store/circle_collection/operations";
import { translatedCircleCollections } from "../../store/circle_collection/selectors";
import { fetchSuggestionsInCollection } from "../../store/circle_suggestion/operations";
import {
  getCircleSuggestionsForSelectedCollection,
  loadingMoreSuggestionsForSelectedCollection,
  loadingInitialSuggestionsForSelectedCollection,
  hasMoreInSelectedCollection,
  getNextOffsetInCollection,
} from "../../store/circle_suggestion/selectors";
import {
  loadingInitialCirclesList,
  getCircles,
  hasMoreCirclesInSelectedCollection,
  getNextOffsetInCirclesCollection,
  loadingMoreCirclesForSelectedCollection,
} from "../../store/circles_in_collection/selectors";

import { fetchCirclesInCollection } from "../../store/circles_in_collection/operations";

import { selectCollection } from "../../store/home_ui/creators";
import { getSelectedCollection } from "../../store/home_ui/selectors";
import LoadMoreCard from "../../components/LoadMoreCard";
import LoadingIndicator from "../../components/LoadingIndicator";
import { navigate } from "../../store/navigation/operations";
import { convertNameToUrl } from "../../utils/utils";
import { HOME_CATEGORIES_ORDER } from "../../config";

export class HomeFeaturedCircles extends Component {
  constructor(props) {
    super(props);

    this.state = {};
    this.showCollection = this.showCollection.bind(this);
    this.handleSuggestionClick = this.handleSuggestionClick.bind(this);
    this.loadMoreSuggestions = this.loadMoreSuggestions.bind(this);
  }

  paramsToCollection = (queryParams) => {
    const paramsToCollectionMap = {
      husqvarna: "husqvarna",
      all: "all",
      alla: "all",
      bat: "boats",
      vattensport: "watersport",
      boats: "boats",
      leisure: "leisure",
      fritid: "leisure",
      garden: "garden",
      tradgard: "garden",
    };
    let collection = undefined;
    queryParams.forEach((param) => {
      if (paramsToCollectionMap[param]) {
        collection = paramsToCollectionMap[param];
      }
    });
    return collection;
  };

  componentDidMount() {
    let selectedCollection = this.paramsToCollection(this.props.queryParams);
    if (selectedCollection === undefined) {
      selectedCollection = HOME_CATEGORIES_ORDER[0];
    }
    this.props.fetchCircleCollections(selectedCollection);
    this.props.selectCollection(selectedCollection);
  }
  loadMoreSuggestions() {
    console.log("LOADING MORE SUGGESTIONS");
    this.props.fetchSuggestionsInCollection(this.props.selectedCollection, 4, this.props.nextSuggestionsOffset, true);
  }

  loadMoreCircles = () => {
    console.log("LOADING MORE Circles");
    this.props.fetchCirclesInCollection(this.props.selectedCollection, 4, this.props.nextCircleCollectionOffset, true);
  };

  showCollection(collectionKey) {
    this.props.fetchSuggestionsInCollection(collectionKey, 4, 0, true);
    this.props.fetchCirclesInCollection(collectionKey, 4, 0, true);
    this.props.selectCollection(collectionKey);
  }

  handleSuggestionClick(suggestion) {
    this.props.navigate(
      `/suggestion/${this.props.selectedCollection}/${convertNameToUrl(suggestion)}/${suggestion.id}`
    );
  }

  handleCircleClick = (circle_guid) => {
    this.props.navigate(`/circle/${circle_guid}/${this.props.selectedCollection}`);
  };

  render() {
    const showLoadingIndicator = Boolean(this.props.loadingInitialSuggestions || this.props.loadingInitialCircles);
    const showSuggestions = Boolean(!this.props.loadingInitialSuggestions && this.props.suggestions.length);
    const showCircles = Boolean(!this.props.loadingInitialCircles && this.props.circles.length);

    return (
      <div id="collection-tabs">
        <HomeCollectionsTabs
          collections={this.props.collections}
          selected={this.props.selectedCollection}
          onTabClick={this.showCollection}
        />
        <section className="circle-showcase">
          <div className="main-container">
            <div className="content-wrapper">
              {showCircles && (
                <div>
                  <h1 className="bp3-heading">
                    <Translate value="home.circle_collection.heading" />
                  </h1>
                  <p>
                    <Translate value="home.circle_collection.subheading" />
                  </p>
                  <div className="scrollable-content">
                    {this.props.circles.map((circle, idx) => (
                      <CircleDecorator circleId={circle.circle_guid} key={circle.circle_guid}>
                        <CircleCard onClick={this.handleCircleClick} />
                      </CircleDecorator>
                    ))}
                    {this.props.hasMoreCircles && (
                      <LoadMoreCard onLoadMoreClick={this.loadMoreCircles} isLoading={this.props.loadingMoreCircles} />
                    )}

                    <div className="spacer" />
                  </div>
                </div>
              )}
              {showLoadingIndicator && <LoadingIndicator />}

              {showSuggestions && (
                <div>
                  <h1 className="bp3-heading">
                    <Translate value="home.circle_suggestions.heading" />
                  </h1>
                  <p>
                    <Translate value="home.circle_suggestions.subheading" />
                  </p>
                  <div className="scrollable-content">
                    {this.props.suggestions.map((suggestion, idx) => (
                      <SuggestionCard
                        key={idx}
                        suggestion={suggestion}
                        onClick={() => {
                          this.handleSuggestionClick(suggestion);
                        }}
                      />
                    ))}
                    {this.props.hasMoreSuggestion && (
                      <LoadMoreCard
                        onLoadMoreClick={this.loadMoreSuggestions}
                        isLoading={this.props.loadingMoreSuggestions}
                      />
                    )}
                    <div className="spacer" />
                  </div>
                </div>
              )}
            </div>
          </div>
        </section>
      </div>
    );
  }
}
const mapStateToProps = (state) => ({
  locale: state.i18n.locale,
  circles: getCircles(state, true),
  loadingInitialCircles: loadingInitialCirclesList(state, true),
  loadingMoreCircles: loadingMoreCirclesForSelectedCollection(state, true),
  nextCircleCollectionOffset: getNextOffsetInCirclesCollection(state, true),
  hasMoreCircles: hasMoreCirclesInSelectedCollection(state, true),
  suggestions: getCircleSuggestionsForSelectedCollection(state, true),
  collections: translatedCircleCollections(state, HOME_CATEGORIES_ORDER),
  selectedCollection: getSelectedCollection(state),
  loadingInitialSuggestions: loadingInitialSuggestionsForSelectedCollection(state, true),
  loadingMoreSuggestions: loadingMoreSuggestionsForSelectedCollection(state, true),
  hasMoreSuggestion: hasMoreInSelectedCollection(state, true),
  nextSuggestionsOffset: getNextOffsetInCollection(state, true),
});
const mapDispatchToProps = (dispatch) => ({
  fetchCircleCollections: (selectedCollection) => dispatch(fetchCircleCollections(selectedCollection)),
  selectCollection: (collection) => dispatch(selectCollection(collection)),
  navigate: (to) => dispatch(navigate(to)),
  fetchSuggestionsInCollection: (collection, limit, offset, featured) =>
    dispatch(fetchSuggestionsInCollection(collection, limit, offset, featured)),
  fetchCirclesInCollection: (collection, limit, offset, featured) =>
    dispatch(fetchCirclesInCollection(collection, limit, offset, featured)),
});
export default connect(mapStateToProps, mapDispatchToProps)(HomeFeaturedCircles);
